import type { FunctionComponent } from 'react';

import { ctw } from '@/common/utils/ctw';

/**
 * EU AI Act (Regulation (EU) 2024/1689) / GDPR Article 22 disclaimer.
 *
 * Rendered at the bottom of every AI-assisted report (Digital Footprint, Point
 * of Sale, Transaction Analysis) on-screen and in PDF exports. Kept as a single
 * exported constant so the text stays identical across every surface — see
 * BAL-7774.
 */
export const AI_ASSISTED_OUTPUT_LABEL = 'AI-Assisted Output.';

export const AI_ASSISTED_OUTPUT_DISCLAIMER =
  'This report has been generated using artificial-intelligence systems, ' +
  'including large language models, applied to publicly available and ' +
  'customer-provided business information. The content is provided for ' +
  'informational and advisory purposes only, does not constitute automated ' +
  'decision-making within the meaning of Article 22 GDPR or the EU AI Act, and ' +
  'is not a regulatory, compliance, or creditworthiness determination. All ' +
  'decisions remain the responsibility of the recipient and require human review.';

type ReportComplianceFooterProps = {
  className?: string;
};

export const ReportComplianceFooter: FunctionComponent<ReportComplianceFooterProps> = ({
  className,
}) => {
  return (
    <div
      className={ctw('flex flex-col gap-y-2 px-5 py-8 text-[11px] text-slate-400', className)}
      data-testid="report-compliance-footer"
    >
      <span className="font-semibold">{AI_ASSISTED_OUTPUT_LABEL}</span>
      <p className="leading-relaxed">{AI_ASSISTED_OUTPUT_DISCLAIMER}</p>
    </div>
  );
};
